import { compose } from 'redux'
import LanguageSelector from '../components/ui/language-selector'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

const mapStateToProps = (
  { survey: { surveyLanguages } }
) => {
  return {
    surveyLanguages,
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps)
)(LanguageSelector)



// WEBPACK FOOTER //
// ./src/containers/language-selector.js